import { Node, mergeAttributes } from "@tiptap/core";

/** Preserve images in saved documents in both member and viewer editors. */
export const DocumentImage = Node.create({
  name: "image",
  group: "block",
  atom: true,
  draggable: true,
  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      title: { default: null },
      width: { default: null },
      height: { default: null },
    };
  },
  parseHTML() {
    return [{ tag: "img[src]" }];
  },
  renderHTML({ HTMLAttributes }) {
    const src = String(HTMLAttributes.src ?? "");
    const safe =
      /^(https?:\/\/|\/(?!\/)|data:image\/(png|jpeg|gif|webp|avif);base64,)/i.test(
        src,
      );
    return [
      "img",
      mergeAttributes(HTMLAttributes, {
        src: safe ? src : "",
        class: "max-w-full h-auto rounded-md",
        referrerpolicy: "no-referrer",
      }),
    ];
  },
});
